import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    isIpad: false,
};

const getters = {};

const mutations = {
    // 判断是否是ipad
    judgeIpad(state, v) {
        state.isIpad = v;
    },

};

const actions = {
    // 保存ipad值
    updateIpad(context, value) {
        context.commit('judgeIpad', value)
    },
};

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    mutations,
    actions
})


// WEBPACK FOOTER //
// ./src/store/store.js